export function Dot() {
  return <div className="h-[3px] w-[3px] rounded-full bg-lynch-500 opacity-50" />;
}
